var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock-filled"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M12 5.33268H11.3334V3.99935C11.3334 2.15935 9.84002 0.666016 8.00002 0.666016C6.16002 0.666016 4.66669 2.15935 4.66669 3.99935V5.33268H4.00002C3.26669 5.33268 2.66669 5.93268 2.66669 6.66602V13.3327C2.66669 14.066 3.26669 14.666 4.00002 14.666H12C12.7334 14.666 13.3334 14.066 13.3334 13.3327V6.66602C13.3334 5.93268 12.7334 5.33268 12 5.33268ZM8.00002 11.3327C7.26669 11.3327 6.66669 10.7327 6.66669 9.99935C6.66669 9.26602 7.26669 8.66602 8.00002 8.66602C8.73335 8.66602 9.33335 9.26602 9.33335 9.99935C9.33335 10.7327 8.73335 11.3327 8.00002 11.3327ZM10.0667 5.33268H5.93335V3.99935C5.93335 2.85935 6.86002 1.93268 8.00002 1.93268C9.14002 1.93268 10.0667 2.85935 10.0667 3.99935V5.33268Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockFilled);
export default __webpack_public_path__ + "static/media/lock-filled.1563ff9c590d0954a86d1d5743b3fc96.svg";
export { ForwardRef as ReactComponent };